import React, { Component } from 'react';

const withMediaQuery = (WrappedComponent) => {
  class WithMediaQuery extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isSmallScreen: window.innerWidth <= 768,
      };
      this.updateScreenSize = this.updateScreenSize.bind(this);
    }

    // eslint-disable-next-line react/sort-comp
    updateScreenSize() {
      this.setState({
        isSmallScreen: window.innerWidth <= 768,
      });
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateScreenSize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateScreenSize);
    }

    render() {
      const { isSmallScreen } = this.state;
      return <WrappedComponent {...this.props} isSmallScreen={isSmallScreen} />;
    }
  }

  return WithMediaQuery;
};

export default withMediaQuery;



// WEBPACK FOOTER //
// ./src/hocs/media-query/MediaQuery.jsx